export default __webpack_public_path__ + "img/f66dbd2a1a5aef650eebf5e6eae5f8d3.png";